<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card class="rounded-lg elevation-0 pa-5 mt-5">
        <v-row class="lg-mt-5">
          <v-col md="6" lg="7" cols="12" class="px-5">
            <div>
              <p class="headline black--text font-weight-medium my-1">Hallo, {{ current_user.nama }}</p>
              <p class="body-1 grey--text">
                Selamat datang di modul diklatku. Dibawah ini merupakan daftar kelas yang telah ditambahkan untuk Anda
                dan sesuai dengan jadwal yang telah Anda set sebelumnya di SIM Guru Penggerak.
              </p>
            </div>
          </v-col>
          <v-col md="1" lg="1" cols="12"></v-col>
          <v-col md="5" lg="4" cols="12">
            <div style="position: relative" class="d-none d-md-flex d-lg-flex">
              <v-img
                fluid
                style="position: absolute; top: -50px; right: 12%; max-width: 250px"
                class="mb-5"
                src="https://penggerak-cdn.siap.id/s3/gurupenggerak/hero-gp.png"
              ></v-img>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col cols="12" v-show="jadwals.length > 0">
      <v-expansion-panels v-model="paneljadwal">
        <v-expansion-panel v-for="(jadwal, i) in jadwals" :key="i">
          <v-expansion-panel-header class="header title grey lighten-3 primary--text"
            >Grup {{ jadwal.grupkelas.nama }} - {{ jadwal.materi.keterangan }}</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <div v-for="kelas in jadwal.grupkelas.kelas" :key="kelas.index">
              <v-row class="mx-3">
                <v-col cols="3" sm="1" md="1" lg="1" align="center">
                  <v-avatar width="50" height="50" :size="45" color="secondary2">
                    <v-icon color="secondary">mdi-google-classroom</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="12" sm="10" md="10" lg="10">
                  <v-row>
                    <v-col class="py-0" cols="12" md="4" sm="4">
                      <p class="caption my-0 py-0 grey--text align-left">Nama Kelas</p>
                      {{ pVal(kelas, "nama") }}
                    </v-col>
                    <v-col class="py-0" cols="12" md="3" sm="5">
                      <p class="caption my-0 py-0 grey--text">Waktu</p>
                      <span class="my-0 py-0"> {{ pVal(jadwal.sesi, "keterangan") }}</span>
                    </v-col>
                    <v-col class="py-0" cols="12" md="3" sm="3">
                      <p class="caption my-0 py-0 grey--text">Nama Fasilitator</p>
                      <span class="my-0 py-0"> </span>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2" xl="2">
                      <m-button
                        v-if="kelas.kelasmodulku[0].created == 1"
                        text="Tautan Modul"
                        icon="mdi-link"
                        :large="false"
                        action="toCourse"
                        color="success"
                        dark
                        @toCourse="toCourse(kelas.kelasmodulku[0])"
                      ></m-button>
                      <m-button
                        v-else-if="kelas.kelasmodulku[0].created == 2"
                        text="Sedang diproses"
                        icon="mdi-sync"
                        :large="false"
                        dark
                        color="orange"
                      ></m-button>
                      <m-button
                        v-else
                        text="Dalam proses"
                        icon="mdi-file-settings"
                        :large="false"
                        dark
                        color="orange"
                      ></m-button>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
    <v-col cols="12" v-show="items.length > 0">
      <p class="title">Daftar Diklat</p>
      <v-expansion-panels v-model="panel">
        <v-expansion-panel v-for="(item, i) in items" :key="i">
          <v-expansion-panel-header class="header title primary--text">Diklat {{ item.nama }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-for="kelas in item.kelasku" :key="kelas.index">
              <v-row v-for="modul in kelas.kelasmodulku" :key="modul.index">
                <v-col cols="1" align="center">
                  <v-avatar width="50" height="50" :size="45" color="secondary2">
                    <v-icon color="secondary">mdi-google-classroom</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="12" sm="12" md="5" lg="5">
                  <p class="font-weight-bold mb-0 pb-0 body-1">Kelas {{ kelas.nama }}</p>
                  <p class="font-weight-light mt-0 pt-0">{{ modul.nama }}</p>
                </v-col>
                <v-col cols="12" sm="12" md="5" lg="5">
                  <p class="font-weight-bold mb-0 pb-0 body-1">Status LMS</p>
                  <p class="font-weight-light mt-0 pt-0">
                    {{
                      modul.created == 1
                        ? "Sinkron"
                        : modul.created == 2
                        ? "Sedang diproses sinkronisasi"
                        : "Dalam proses sinkronisasi"
                    }}
                  </p>
                </v-col>
                <v-col lg="1" md="1" sm="1" cols="1">
                  <m-menu
                    right
                    class="clearfix"
                    style="float:right"
                    :items="more_menu"
                    :object="{ ...modul, diklat: { ...kelas.diklat } }"
                  />
                </v-col>
              </v-row>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <TimespentDlg ref="timespentDlg" />
      <TimespentEmbedDlg ref="timespentEmbedDlg" />
    </v-col>
  </v-row>
</template>

<script>
import { ALERT_INFO } from "@/const";
import ChangeDlg from "../../diklat/components/Form.vue";
import TimespentDlg from "../../kelas/components/Timespent.vue";
import TimespentEmbedDlg from "../../diklat/components/TimespentEmbed.vue";

export default {
  components: {
    ChangeDlg,
    TimespentDlg,
    TimespentEmbedDlg
  },
  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      jadwals: [],
      page: null,
      panel: 0,
      paneljadwal: 0,
      cp: 1,
      METABASE_SITE_URL: "https://metabase.simpkb.id"
    };
  },
  computed: {
    more_menu() {
      return [
        // eslint-disable-next-line
        {
          title: "Tautan LMS",
          icon: "mdi-link",
          color: "success",
          click: (i, o) => this.toCourse(o),
          check: (i, o) => o.created == 1
        },
        {
          title: "Timespent",
          icon: "mdi-clock",
          color: "success",
          click: (i, o) => this.toTimespent(o),
          check: (i, o) => o.grup_id == 6 && o.diklat.jenis_diklat_id < 141?true:false
        },
        {
          title: "Unduhan TS Fasilitator",
          icon: "mdi-file-pdf",
          color: "success",
          click: (i, o) => this.toUnduhTS(o),
          check: (i, o) => o.grup_id == 4 || o.grup_id == 6
        },
        {
          title: "Timespent",
          icon: "mdi-clock",
          color: "info",
          click: (i, o) => this.toTimespentEmbed(o),
          check: (i, o) => o.grup_id == 6 && o.diklat.jenis_diklat_id >= 141?true:o.grup_id == 4 && o.diklat.jenis_diklat_id == 149?true:false
        },
        {
          title: "Klaim Rekaman",
          icon: "mdi-video-plus",
          color: "orange",
          click: (i, o) => this.goTo(o),
          check: (i, o) => o.grup_id == 4 || o.grup_id == 6
        }
      ];
    },

    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    }
  },
  activated() {
    this.load();
    // this.loadJadwal();
    this.paneljadwal = 0;
  },
  methods: {
    load() {
      return this.$store
        .dispatch("diklat/getDiklatku", {
          instansi_id: this.instansi_id,
          params: {
            page: this.cp,
            s: this.textSearch,
            peran: this.peran
          }
        })
        .then(res => {
          // this.page = res;
          this.items = res;
        })
        .catch(e => e);
    },

    goTo(val) {
      this.$router.push({
        name: "rekamanku.detail",
        params: {
          instansi_id: val.kelas.instansi_id,
          kelas_id: val.kelas.id,
          nama_kelas: val.kelas.keterangan
        }
      });
    },

    loadJadwal() {
      return this.$store
        .dispatch("diklat/getJadwals", {
          instansi_id: this.instansi_id
        })
        .then(res => {
          this.jadwals = res;
        })
        .catch(e => e);
    },

    toCourse(val) {
      window.open(val.link_moodle, "_blank");
    },

    toTimespent(obj) {
      this.$refs.timespentDlg.open(obj);
    },

    toUnduhTS(obj){
      var token = this.$store.getters["user/token"];
      return this.$store
        .dispatch("diklat/unduhTSFasil", {
          instansi_id: this.instansi_id,
          kelas_id: obj.kelas_id,
          params: {
            access_token: token
          }
        })
        .catch(e => e);
    },

    toTimespentEmbed(obj) {
      var jwt = require("jsonwebtoken");

      var METABASE_SECRET_KEY = "7b48e151023b77a7f08fad06da8b4686ff34923d06f85f64fe0a571d3c18ed79";

      var payload = {
        resource: { dashboard: 431 },
        params: {
          instansi_id: this.instansi_id,
          kelas_id_sim: obj.kelas_id,
          user_id_sim: this.current_user.id
        },
        exp: Math.round(Date.now() / 1000) + 10 * 60 // 10 minute expiration
      };

      var token = jwt.sign(payload, METABASE_SECRET_KEY);

      this.iframeUrl = this.METABASE_SITE_URL + "/embed/dashboard/" + token + "#bordered=true&titled=false";
      this.$refs.timespentEmbedDlg.open(this.iframeUrl,obj).then(() => {
        this.load();
      });
    }
  }
};
</script>
